export default function convertDateToHM(date) {
  return {
    hour: date.getHours(),
    minute: date.getMinutes(),
  };
}
